/* eslint-disable @next/next/no-img-element */
/* eslint-disable max-len */
import React from 'react'
import { Select } from 'antd'
import type { TFunction } from 'next-i18next'
import { Country, Currency, ProjectOption } from 'src/core/models'
import { CustomSelect, CustomInputNumber, CustomText, CustomInputDecimal, CountrySelector } from 'src/components'

interface FormProps {
  name: string,
  placeholder: string,
  required?: boolean
  mode?: string,
  listHeight?: number,
  onChange?: Function,
  min?: number
  tokenSeparators?: string[],
  manageFiltering?: Function
  addonAfter?: React.ReactNode
}

interface ProposalFormSection {
  isRow?: boolean
  addBr?: boolean,
  leftLabel?: string,
  formComponent: React.FunctionComponent<FormProps | any>, // Conflict with Select Props
  formProps: FormProps,
  formChildren?: React.ReactNode,
  downLabel?: string,
}


export const proposalFormSections = (
  t: TFunction, standardList: ProjectOption[], typeList: ProjectOption[],
  countryList: Country[], styles: any, currencyList: Currency[], measure: string,
  handleProjectTypeChange: Function
): ProposalFormSection[] =>[

  { // Project Type
    formComponent: CustomSelect,
    formProps: {
      name: 'project_type',
      placeholder: t('RequestProposal.ProjectTypePlaceholder'),
      required: true,
      onChange: (value: string) => handleProjectTypeChange(value)
    },
    formChildren: <>
      <Select.Option value={'compensation'}>{`${t('Projects.Compensation')}`}</Select.Option>
      <Select.Option value={'energy'}>{`${t('Projects.Energy')}`}</Select.Option>
    </>,
    downLabel: t('RequestProposal.ProjectTypelabel')
  },

  { // Standard
    addBr: true,
    formComponent: CustomSelect,
    formProps: {
      name: 'standards',
      placeholder: t('RequestProposal.StandardsPlaceholder'),
      mode: 'multiple',
      listHeight: 300,
      tokenSeparators: [' ', ',']
    },
    formChildren: <>{standardList.map((standard, idx) => <Select.Option key={idx} value={standard.value}>{standard.value}</Select.Option>)}</>,
    downLabel: t('RequestProposal.StandardLabel')
  },

  { // Country
    addBr: true,
    formComponent: CountrySelector,
    formProps: {
      name: 'countries',
      placeholder: t('RequestProposal.CountriesPlaceholder'),
      mode: 'multiple',
      listHeight: 300,
      tokenSeparators: [' ', ','],
    },
    downLabel: t('RequestProposal.CountryLabel'),
  },

  { // Standard
    addBr: true,
    formComponent: CustomSelect,
    formProps: {
      name: 'types',
      placeholder: t('RequestProposal.TypesPlaceholder'),
      mode: 'multiple',
      listHeight: 300,
      tokenSeparators: [' ', ',']
    },
    formChildren: <>{typeList.map((type, idx) => <Select.Option key={idx} value={type.value}>{type.value}</Select.Option>)}</>,
    downLabel: t('RequestProposal.TypesLabel')
  },

  { // Stock
    isRow: true,
    leftLabel: t('RequestProposal.StockLabel'),
    formComponent: CustomInputNumber,
    formProps: {
      name: 'stock',
      placeholder: t('admin.Brokerage.StockPlaceHolder'),
      min: 2000,
      addonAfter: <CustomText label={measure} type='secondary' />,
      required: true
    }
  },

  { // Price
    isRow: true,
    leftLabel: t('RequestProposal.Measure', { measure }),
    formComponent: CustomInputDecimal,
    formProps: {
      name: 'price',
      placeholder: t('admin.Brokerage.PricePlaceHolder'),
      required: true
    }
  },

  { // Currency
    isRow: true,
    leftLabel: t('RequestProposal.CurrencyLabel'),
    formComponent: CustomSelect,
    formProps: {
      name: 'currency',
      placeholder: t('RequestProposal.CurrencyPlaceHolder'),
      required: true
    },
    formChildren: <>{currencyList.map((c, idx) => <Select.Option key={idx} value={c.id}>{c.code}</Select.Option>)}</>,
  },
]
